module.exports = __webpack_public_path__ + "img/fish_tropicalfish.0eaf900e.png";